// extracted by mini-css-extract-plugin
export default {"underlined":"style_underlined__LppM8","disabled":"style_disabled__2uL-u"};